export default __webpack_public_path__ + "static/media/YardView.ef8f8965.png";